export function roundNumber (_number, _decimals) {
  if (!Number.isFinite(_number)) return _number

  const number = parseFloat(_number)
  const decimals = _decimals || 0

  const powerDecimals = Math.pow(10, decimals)
  return Math.round(number * powerDecimals) / powerDecimals
}
